/*ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
 ÃƒÂ°Ã…Â¸Ã…â€™Ã‚Â Project: Ring2All Platform
 ÃƒÂ°Ã…Â¸Ã‚Â§Ã¢â‚¬ËœÃƒÂ¢Ã¢â€šÂ¬Ã‚ÂÃƒÂ°Ã…Â¸Ã¢â‚¬â„¢Ã‚Â» Author: Rodrigo Cuadra
 ÃƒÂ°Ã…Â¸Ã‚ÂÃ‚Â¢ Company: Ring2All LLC
 ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã¢â‚¬Å¾ File: CallbackRulesFormView.tsx
 ÃƒÂ°Ã…Â¸Ã¢â‚¬â€Ã¢â‚¬Å“ÃƒÂ¯Ã‚Â¸Ã‚Â Created: 2025-01-27
 ÃƒÂ°Ã…Â¸Ã‚Â§Ã‚Â© Description:
    Form view for creating and editing Callback Rules.
    Manages callback configuration with General and Settings sections.

 ÃƒÂ°Ã…Â¸Ã¢â‚¬ÂÃ‚Â§ Notes:
    - Domain-scoped data
    - Auto-generates context from name
    - Two sections: General and Settings

 ÃƒÂ°Ã…Â¸Ã¢â‚¬ÂÃ‚Â Last Updated: 2025-01-27 by Rodrigo Cuadra
ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬*/

import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { PhoneIncoming, Phone, Settings, Search, Copy, Plus } from 'lucide-react';
import { useI18n } from '../../hooks/useI18n';
import { useNotifications } from '../../hooks/useNotifications';
import { buildApiUrl, getApiHeaders } from '../../config/api';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import Toggle from '../../components/ui/Toggle';
import FixedActionBar from '../../components/ui/FixedActionBar';
import ConfirmationModal from '../../components/ui/ConfirmationModal';
import { ModuleFormHeader } from '../../components/layouts';
import { QuickSearchModal } from '../../components/ui/QuickSearchModal';
import RecordingSelect from '../../components/ui/RecordingSelect';
import { SimpleTooltip } from '../../components/ui/SimpleTooltip';
import { FormBox } from '../../components/ui/FormBox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select-shadcn';
import ModuleDestinationSelect from '../../components/ui/ModuleDestinationSelect';
import SelectClassOfService from '../../components/ui/SelectClassOfService';
import { useSaveWithAction } from '../../hooks/useSaveWithAction';
import {
  deleteCallbackRuleById,
  navigateToCallbackRuleDuplicate,
} from './callbackRulesActions';

interface NotificationSettings {
  method: 'none' | 'email' | 'api' | 'event';
  target: string;
}

interface FormSettings {
  delaySeconds: number;
  dialPrefix: string;
  retryCount: number;
  maxWaitTime: number;
  recordCall: boolean;
  hangupAfterCallback: boolean;
  announcementPath: string;
  ringbackTone: 'us-ring' | 'uk-ring' | 'fr-ring' | 'none';
  originValidationMode: 'none' | 'caller_id' | 'cos' | 'list';
  allowedCallers: string[];
  callbackStrategy: 'immediate' | 'scheduled' | 'queue';
  notification: NotificationSettings;
}

interface FormState {
  callbackNumber: string;
  name: string;
  description: string;
  context: string;
  destinationModule: string;
  destinationValue: string;
  classOfServicesId: number | null;
  enabled: boolean;
  askForCallbackNumber: boolean;
  settings: FormSettings;
}

const DEFAULT_SETTINGS: FormSettings = {
  delaySeconds: 5,
  dialPrefix: '',
  retryCount: 1,
  maxWaitTime: 20,
  recordCall: false,
  hangupAfterCallback: false,
  announcementPath: '',
  ringbackTone: 'us-ring',
  originValidationMode: 'none',
  allowedCallers: [],
  callbackStrategy: 'immediate',
  notification: {
    method: 'none',
    target: ''
  }
};

const DEFAULT_FORM_STATE: FormState = {
  callbackNumber: '',
  name: '',
  description: '',
  context: '',
  destinationModule: '',
  destinationValue: '',
  classOfServicesId: null,
  enabled: true,
  askForCallbackNumber: true,
  settings: { ...DEFAULT_SETTINGS, notification: { ...DEFAULT_SETTINGS.notification }, allowedCallers: [] }
};

const RINGBACK_TONES: Array<FormSettings['ringbackTone']> = ['us-ring', 'uk-ring', 'fr-ring', 'none'];
const ORIGIN_VALIDATION_MODES: Array<FormSettings['originValidationMode']> = ['none', 'caller_id', 'cos', 'list'];
const CALLBACK_STRATEGIES: Array<FormSettings['callbackStrategy']> = ['immediate', 'scheduled', 'queue'];

import { CallbackRuleSettingsSection } from './components/CallbackRuleSettingsSection';

export default function CallbackRulesFormView() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const duplicateId = searchParams.get('duplicate');
  const isEditMode = Boolean(id && id !== 'new');
  const navigate = useNavigate();
  const { t } = useI18n();
  const { notifications, removeNotification, showSuccess, showError, showInfo } = useNotifications();

  const lastSaveRef = useRef<number>(0);
  const lastLoadedIdRef = useRef<string | null>(null);
  const showErrorRef = useRef(showError);

  useEffect(() => {
    showErrorRef.current = showError;
  }, [showError]);

  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showAllowedCallersModal, setShowAllowedCallersModal] = useState(false);

  const [classOfServices, setClassOfServices] = useState<Array<{ id: number; name: string }>>([]);
  const [availableExtensions, setAvailableExtensions] = useState<Array<{ id: string; name: string; description: string; slug: string }>>([]);

  const [formData, setFormData] = useState<FormState>({ ...DEFAULT_FORM_STATE });
  const [originalData, setOriginalData] = useState<FormState>({ ...DEFAULT_FORM_STATE });
  const [errors, setErrors] = useState<Record<string, string>>({});

  const hasChanges = useMemo(() => JSON.stringify(formData) !== JSON.stringify(originalData), [formData, originalData]);

  // Quick List (Callback Rules) states
  const [showQuickList, setShowQuickList] = useState(false);
  const [quickListSearch, setQuickListSearch] = useState('');
  const [quickListItems, setQuickListItems] = useState<Array<{ id: string | number; name?: string; code?: string; uuid?: string }>>([]);
  const [initialItems, setInitialItems] = useState<Array<{ id: string | number; name?: string; code?: string; uuid?: string }>>([]);
  const [isLoadingInitial, setIsLoadingInitial] = useState(false);
  const [isQuickSearching, setIsQuickSearching] = useState(false);

  const generateContext = useCallback((name: string) => {
    return name
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, '')
      .replace(/\s+/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_|_$/g, '')
      .slice(0, 50);
  }, []);

  const normalizeSettings = useCallback((incoming: unknown): FormSettings => {
    const base: FormSettings = {
      ...DEFAULT_SETTINGS,
      notification: { ...DEFAULT_SETTINGS.notification },
      allowedCallers: []
    };

    const raw = (typeof incoming === 'object' && incoming !== null ? incoming : {}) as Record<string, unknown>;
    base.delaySeconds = Math.min(600, Math.max(0, Number(raw.delaySeconds ?? raw.delay_seconds ?? base.delaySeconds)));
    base.dialPrefix = String(raw.dialPrefix ?? raw.dial_prefix ?? base.dialPrefix ?? '').slice(0, 16);
    base.retryCount = Math.min(5, Math.max(0, Number(raw.retryCount ?? raw.retry_count ?? base.retryCount)));
    base.maxWaitTime = Math.min(120, Math.max(0, Number(raw.maxWaitTime ?? raw.max_wait_time ?? base.maxWaitTime)));
    base.recordCall = Boolean(raw.recordCall ?? raw.record_call ?? base.recordCall);
    base.hangupAfterCallback = Boolean(raw.hangupAfterCallback ?? raw.hangup_after_callback ?? base.hangupAfterCallback);
    base.announcementPath = String(raw.announcementPath ?? raw.announcement_path ?? base.announcementPath ?? '').slice(0, 255);

    const ringback = String(raw.ringbackTone ?? raw.ringback_tone ?? base.ringbackTone).toLowerCase();
    base.ringbackTone = (RINGBACK_TONES.includes(ringback as FormSettings['ringbackTone']) ? ringback : base.ringbackTone) as FormSettings['ringbackTone'];

    const originMode = String(raw.originValidationMode ?? raw.origin_validation_mode ?? base.originValidationMode).toLowerCase();
    base.originValidationMode = (ORIGIN_VALIDATION_MODES.includes(originMode as FormSettings['originValidationMode']) ? originMode : base.originValidationMode) as FormSettings['originValidationMode'];

    const allowedRaw = Array.isArray(raw['allowedCallers'] ?? raw['allowed_callers']) ? (raw['allowedCallers'] ?? raw['allowed_callers']) as unknown[] : [];
    base.allowedCallers = Array.from(new Set(allowedRaw.map((value) => String(value).slice(0, 64)).filter(Boolean)));

    const callbackStrategy = String(raw.callbackStrategy ?? raw.callback_strategy ?? base.callbackStrategy).toLowerCase();
    base.callbackStrategy = (CALLBACK_STRATEGIES.includes(callbackStrategy as FormSettings['callbackStrategy']) ? callbackStrategy : base.callbackStrategy) as FormSettings['callbackStrategy'];

    const notification = (typeof raw['notification'] === 'object' && raw['notification'] !== null ? raw['notification'] : {}) as Record<string, unknown>;
    const method = String(notification['method'] ?? base.notification.method).toLowerCase();
    base.notification.method = (['none', 'email', 'api', 'event'].includes(method) ? method : base.notification.method) as NotificationSettings['method'];
    base.notification.target = String(notification['target'] ?? base.notification.target).slice(0, 255);

    return base;
  }, []);

  const loadClassOfServices = useCallback(async () => {
    try {
      const response = await fetch(
        buildApiUrl('/api/telephony/class-of-services?limit=1000'),
        { headers: getApiHeaders() }
      );

      if (!response.ok) {
        throw new Error();
      }

      const result = await response.json();
      const items = Array.isArray(result?.data) ? result.data.map((cos: { id: number; name: string }) => ({ id: cos.id, name: cos.name })) : [];
      setClassOfServices(items);
    } catch (error) {
      showErrorRef.current(t('callbackRules:messages.loadClassOfServiceError'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadExtensions = useCallback(async () => {
    try {
      const response = await fetch(
        buildApiUrl('/api/telephony/extensions?limit=1000&sortBy=extension&sortOrder=asc'),
        { headers: getApiHeaders() }
      );

      if (!response.ok) {
        throw new Error();
      }

      const result = await response.json();
      const items = Array.isArray(result?.data)
        ? result.data.map((ext: { extension: string; name?: string }) => ({
          id: String(ext.extension),
          name: `${ext.extension}${ext.name ? ` - ${ext.name}` : ''}`,
          description: ext.name || '',
          slug: String(ext.extension)
        }))
        : [];

      setAvailableExtensions(items);
    } catch (error) {
      showErrorRef.current(t('callbackRules:messages.loadExtensionsError'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadCallbackRule = useCallback(
    async (loadId: string, duplicate: boolean = false) => {
      setIsLoading(true);
      try {
        const response = await fetch(
          buildApiUrl(`/api/telephony/callback-rules/${loadId}`),
          { headers: getApiHeaders() }
        );

        if (!response.ok) {
          throw new Error();
        }

        const result = await response.json();
        const rule = result?.data;

        if (!rule) {
          throw new Error();
        }

        // Map backend snake_case to frontend camelCase
        const loaded: FormState = {
          callbackNumber: rule.callbackNumber ?? rule.callback_number ?? rule.code ?? '',
          name: rule.name || '',
          description: rule.description || '',
          context: rule.context || '',
          destinationModule: rule.destination_module || rule.destinationModule || '',
          destinationValue: rule.destination_value || rule.destinationValue || '',
          classOfServicesId: rule.class_of_services_id ?? rule.classOfServicesId ?? null,
          enabled: rule.enabled ?? true,
          askForCallbackNumber: rule.ask_for_callback_number ?? rule.askForCallbackNumber ?? true,
          settings: normalizeSettings(rule.settings)
        };

        const copySuffix = t('common.copySuffix', 'Copy');
        const finalData = duplicate
          ? {
            ...loaded,
            callbackNumber: '',
            name: loaded.name
              ? `${loaded.name} ${copySuffix}`.trim()
              : loaded.name
          }
          : loaded;

        setFormData(finalData);
        setOriginalData(finalData);
        setErrors({});
      } catch (error) {
        showErrorRef.current(t('callbackRules:messages.loadError'));
        throw error;
      } finally {
        setIsLoading(false);
      }
    },
    [normalizeSettings, t]
  );

  useEffect(() => {
    loadClassOfServices();
    loadExtensions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const loadTargetId = duplicateId || id;

    if (!loadTargetId || loadTargetId === 'new') {
      // Only reset if we haven't already reset for this 'new' state
      if (lastLoadedIdRef.current !== 'new') {
        lastLoadedIdRef.current = 'new';

        // Clear any saved data to ensure fresh form
        const savedDataKey = 'callbackRules:saveAndNewData';
        try {
          sessionStorage.removeItem(savedDataKey);
        } catch (error) {
          // Ignore errors when clearing
        }

        if (!duplicateId) {
          setFormData({ ...DEFAULT_FORM_STATE });
          setOriginalData({ ...DEFAULT_FORM_STATE });
        }
      }
      return;
    }

    if (lastLoadedIdRef.current === loadTargetId) {
      return;
    }

    lastLoadedIdRef.current = loadTargetId;

    loadCallbackRule(loadTargetId, Boolean(duplicateId)).catch(() => {
      lastLoadedIdRef.current = null;
    });
  }, [duplicateId, id, loadCallbackRule]);

  const handleFieldChange = useCallback((field: keyof FormState, value: string | number | boolean | null) => {
    setFormData((prev) => {
      const next = { ...prev, [field]: value } as FormState;
      if (field === 'name' && typeof value === 'string' && value.trim()) {
        next.context = generateContext(value);
      }
      return next;
    });

    if (errors[field as string]) {
      setErrors((prev) => {
        const updated = { ...prev };
        delete updated[field as string];
        return updated;
      });
    }
  }, [errors, generateContext]);

  const handleSettingsChange = useCallback(<K extends keyof FormSettings>(key: K, value: FormSettings[K]) => {
    setFormData((prev) => ({
      ...prev,
      settings: {
        ...prev.settings,
        [key]: value
      }
    }));
  }, []);

  const handleNotificationChange = useCallback((key: keyof NotificationSettings, value: string) => {
    setFormData((prev) => ({
      ...prev,
      settings: {
        ...prev.settings,
        notification: {
          ...prev.settings.notification,
          [key]: value
        }
      }
    }));

    if (key === 'target' && errors.notification_target) {
      setErrors((prev) => {
        const updated = { ...prev };
        delete updated.notification_target;
        return updated;
      });
    }
  }, [errors.notification_target]);

  const validateForm = useCallback(() => {
    const validationErrors: Record<string, string> = {};

    if (!formData.name.trim()) {
      validationErrors.name = t('callbackRules:validation.nameRequired');
    }

    if (!formData.destinationModule.trim()) {
      validationErrors.destinationModule = t('callbackRules:validation.destinationModuleRequired');
    }

    if (!formData.destinationValue.trim()) {
      validationErrors.destinationValue = t('callbackRules:validation.destinationValueRequired');
    }

    if (formData.settings.delaySeconds < 0 || formData.settings.delaySeconds > 600) {
      validationErrors.delaySeconds = t('callbackRules:validation.delaySecondsRequired');
    }

    if (formData.settings.retryCount < 0 || formData.settings.retryCount > 5) {
      validationErrors.retryCount = t('callbackRules:validation.retryCountRequired');
    }

    if (formData.settings.maxWaitTime < 0 || formData.settings.maxWaitTime > 120) {
      validationErrors.maxWaitTime = t('callbackRules:validation.maxWaitTimeRequired');
    }

    if (formData.settings.notification.method !== 'none' && !formData.settings.notification.target.trim()) {
      validationErrors.notification_target = t('callbackRules:validation.notificationTargetRequired');
    }

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      showErrorRef.current(t('callbackRules:messages.fixValidationErrors'));
      return false;
    }

    return true;
  }, [formData, t]);

  const handleSubmit = useCallback(async () => {
    if (!validateForm()) {
      return undefined;
    }

    const now = Date.now();
    if (now - lastSaveRef.current < 1000) {
      return undefined;
    }
    lastSaveRef.current = now;

    setIsSaving(true);
    try {
      const payloadSettings = {
        delay_seconds: formData.settings.delaySeconds,
        dial_prefix: formData.settings.dialPrefix || null,
        retry_count: formData.settings.retryCount,
        max_wait_time: formData.settings.maxWaitTime,
        record_call: formData.settings.recordCall,
        hangup_after_callback: formData.settings.hangupAfterCallback,
        announcement_path: formData.settings.announcementPath || null,
        ringback_tone: formData.settings.ringbackTone,
        origin_validation_mode: formData.settings.originValidationMode,
        allowed_callers: formData.settings.allowedCallers,
        callback_strategy: formData.settings.callbackStrategy,
        notification: formData.settings.notification
      };

      const payload: {
        callbackNumber: string | null;
        name: string;
        description: string | null;
        context: string;
        destinationModule: string;
        destinationValue: string;
        enabled: boolean;
        askForCallbackNumber: boolean;
        settings: typeof payloadSettings;
        classOfServicesId?: number | null;
      } = {
        callbackNumber: formData.callbackNumber?.trim() || null,
        name: formData.name.trim(),
        description: formData.description.trim() || null,
        context: (formData.context || generateContext(formData.name)).trim(),
        destinationModule: formData.destinationModule.trim(),
        destinationValue: formData.destinationValue.trim(),
        enabled: formData.enabled,
        askForCallbackNumber: formData.askForCallbackNumber,
        settings: payloadSettings
      };

      // Only include classOfServicesId if it has a value
      if (formData.classOfServicesId !== null && formData.classOfServicesId !== undefined) {
        payload.classOfServicesId = formData.classOfServicesId;
      }

      const url = isEditMode
        ? buildApiUrl(`/api/telephony/callback-rules/${id}`)
        : buildApiUrl('/api/telephony/callback-rules');
      const method = isEditMode ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: {
          ...getApiHeaders(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(t('callbackRules:messages.saveError'));
      }

      const result = await response.json();

      if (!result?.success) {
        throw new Error(result?.message || t('callbackRules:messages.saveError'));
      }

      showSuccess(
        isEditMode
          ? t('callbackRules:messages.saveSuccessUpdate')
          : t('callbackRules:messages.saveSuccessCreate')
      );

      const persistedContext = payload.context;
      const nextOriginal = {
        ...formData,
        context: persistedContext
      };
      setOriginalData(nextOriginal);
      setFormData(nextOriginal);

      // Return saved data (navigation is now handled by useSaveWithAction)
      return result.data || { ...payload, id: result.data?.id };
    } catch (error) {
      showErrorRef.current(error instanceof Error ? error.message : t('callbackRules:messages.saveError'));
      throw error;
    } finally {
      setIsSaving(false);
    }
  }, [formData, generateContext, hasChanges, id, isEditMode, showInfo, showSuccess, t, validateForm]);

  const handleDeleteConfirm = useCallback(async () => {
    if (!isEditMode || !id) return;

    setIsDeleting(true);
    try {
      await deleteCallbackRuleById(id);

      showSuccess(t('callbackRules:messages.deleteSuccess'));
      navigate('/pbx/applications/callback');
    } catch (error) {
      showErrorRef.current(error instanceof Error ? error.message : t('callbackRules:messages.deleteError'));
      setShowDeleteModal(false);
    } finally {
      setIsDeleting(false);
    }
  }, [id, isEditMode, navigate, showSuccess, t]);

  // Enhanced save handler
  const handleSaveInternal = useCallback(async () => {
    const savedData = await handleSubmit();

    // If no changes were detected, return current data to allow navigation
    if (!savedData && isEditMode && id) {
      return { id, ...formData };
    }

    return savedData;
  }, [handleSubmit, formData, isEditMode, id]);

  // Use reusable hook for save actions
  const modeForSave = isEditMode ? 'edit' : 'create';
  const handleSaveWithAction = useSaveWithAction({
    onSave: handleSaveInternal,
    listPath: '/pbx/applications/callback',
    newPath: '/pbx/applications/callback/new',
    mode: modeForSave,
    getEditPath: (savedData) => `/pbx/applications/callback/${savedData.id || savedData.uuid}`,
    getFormData: () => formData,
    storageKey: 'callbackRules:saveAndNewData',
  });

  const handleCancel = useCallback(() => {
    if (isEditMode) {
      setFormData(originalData);
      setErrors({});
    } else {
      setFormData({ ...DEFAULT_FORM_STATE });
      setOriginalData({ ...DEFAULT_FORM_STATE });
      setErrors({});
    }
  }, [isEditMode, originalData]);

  // Reset load guard on unmount - ensures navigating back to the same ID always reloads fresh data
  useEffect(() => {
    return () => {
      lastLoadedIdRef.current = null;
    };
  }, []);

  const handleDuplicateFromForm = () => {
    if (!isEditMode || !id) return;
    navigateToCallbackRuleDuplicate(navigate, id);
  };

  // Navigate to new
  const handleAddNew = () => {
    navigate('/pbx/applications/callback/new');
  };

  // Quick List loader for Callback Rules
  // Load initial items when Quick List modal opens
  const loadInitialItems = useCallback(async () => {
    if (initialItems.length > 0) return; // Already loaded

    setIsLoadingInitial(true);
    try {
      const params = new URLSearchParams({
        page: '1',
        limit: '100',
        sortBy: 'code',
        sortOrder: 'asc'
      });

      const response = await fetch(
        buildApiUrl(`/api/telephony/callback-rules?${params.toString()}`),
        { headers: getApiHeaders() }
      );

      if (response.ok) {
        const result = await response.json();
        if (result?.success && Array.isArray(result.data)) {
          setInitialItems(result.data);
          setQuickListItems(result.data);
        }
      }
    } catch (error) {
      console.error('Error loading initial items:', error);
    } finally {
      setIsLoadingInitial(false);
    }
  }, [initialItems.length]);

  const loadQuickList = useCallback(async (search: string) => {
    const normalized = search.trim();

    // If search is empty or less than 2 characters, restore initial items
    if (!normalized || normalized.length < 2) {
      setQuickListItems(initialItems);
      return;
    }

    setIsQuickSearching(true);
    try {
      const params = new URLSearchParams({
        page: '1',
        limit: '50',
        sortBy: 'code',
        sortOrder: 'asc',
        search: normalized
      });

      const response = await fetch(
        buildApiUrl(`/api/telephony/callback-rules?${params.toString()}`),
        { headers: getApiHeaders() }
      );

      if (response.ok) {
        const result = await response.json();
        if (result?.success && Array.isArray(result.data)) {
          setQuickListItems(result.data);
        }
      }
    } catch (error) {
      console.error('Error loading quick list items:', error);
    } finally {
      setIsQuickSearching(false);
    }
  }, [initialItems]);

  // Load initial items when Quick List modal opens
  useEffect(() => {
    if (showQuickList && initialItems.length === 0) {
      loadInitialItems();
    }
  }, [showQuickList, initialItems.length, loadInitialItems]);

  // Debounced Quick List search
  useEffect(() => {
    if (!showQuickList) return;

    const timer = setTimeout(() => {
      if (quickListSearch.trim().length >= 2) {
        loadQuickList(quickListSearch);
      } else {
        // Restore initial items if search is cleared
        setQuickListItems(initialItems);
      }
    }, 800);

    return () => clearTimeout(timer);
  }, [quickListSearch, showQuickList, loadQuickList, initialItems]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4" />
          <p className="text-muted-foreground">{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6"><ModuleFormHeader
      icon={<PhoneIncoming className="h-5 w-5 text-primary" />}
      title={isEditMode ? `${t('callbackRules:editTitle')} - ${formData.name || ''}` : t('callbackRules:createTitle')}
      backButtonText={t('callbackRules:actions.back')}
      onBack={() => navigate('/pbx/applications/callback')}
      actions={[
        // 1. Quick Search (always visible)
        {
          icon: <Search className="h-5 w-5 text-muted-foreground" />,
          tooltip: t('callbackRules:actions.quickList'),
          onClick: () => setShowQuickList(true)
        },
        // 2. Duplicate (edit mode only)
        ...(isEditMode
          ? [{
            icon: <Copy className="h-5 w-5 text-muted-foreground" />,
            tooltip: t('callbackRules:actions.duplicate'),
            onClick: handleDuplicateFromForm
          }]
          : []),
        // 3. Add New (always visible)
        {
          icon: <Plus className="h-5 w-5 text-muted-foreground" />,
          tooltip: t('callbackRules:actions.add'),
          onClick: handleAddNew,
        }
      ]}
    />

      <div className="mt-8">
        <form
          onSubmit={(event) => {
            event.preventDefault();
            handleSubmit();
          }}
          className="space-y-6"
        >
          <FormBox
            title={t('callbackRules:sections.general')}
            icon={<PhoneIncoming className="h-5 w-5" />}
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 items-center">
              {/* Name - primary identifier, always first */}
              <Label htmlFor="name">
                <SimpleTooltip content={t('callbackRules:fields.name.tooltip')}>
                  <span>
                    {t('callbackRules:fields.name.label')}
                    <span className="text-red-500 ml-1">*</span>
                  </span>
                </SimpleTooltip>
              </Label>
              <div>
                <Input
                  id="name"
                  value={formData.name}
                  onChange={(event) => handleFieldChange('name', event.target.value)}
                  placeholder={t('callbackRules:fields.name.placeholder')}
                  className={errors.name ? 'border-red-500' : ''}
                />
                {errors.name && <p className="text-sm text-red-500 mt-1">{errors.name}</p>}
              </div>

              {/* Number - optional, who to call back (blank = use CallerID) */}
              <Label htmlFor="callbackNumber">
                <SimpleTooltip content={t('callbackRules:fields.callbackNumber.tooltip')}>
                  {t('callbackRules:fields.callbackNumber.label')}
                </SimpleTooltip>
              </Label>
              <div>
                <Input
                  id="callbackNumber"
                  value={formData.callbackNumber}
                  onChange={(event) => handleFieldChange('callbackNumber', event.target.value)}
                  placeholder={t('callbackRules:fields.callbackNumber.placeholder')}
                />
              </div>

              <Label htmlFor="destinationModule">
                <SimpleTooltip content={t('callbackRules:fields.destination.tooltip')}>
                  <span>
                    {t('callbackRules:fields.destination.label')}
                    <span className="text-red-500 ml-1">*</span>
                  </span>
                </SimpleTooltip>
              </Label>
              <div className="col-span-3">
                <ModuleDestinationSelect
                  moduleValue={formData.destinationModule}
                  destinationValue={formData.destinationValue}
                  onModuleChange={(value) => handleFieldChange('destinationModule', value || '')}
                  onDestinationChange={(value) => handleFieldChange('destinationValue', value || '')}
                  modulePlaceholder={t('callbackRules:fields.destination.modulePlaceholder')}
                  destinationPlaceholder={t('callbackRules:fields.destination.destinationPlaceholder')}
                />
                {(errors.destinationModule || errors.destinationValue) && (
                  <p className="text-sm text-red-500 mt-1">
                    {errors.destinationModule || errors.destinationValue}
                  </p>
                )}
              </div>

              <Label htmlFor="classOfServicesId">
                <SimpleTooltip content={t('callbackRules:fields.classOfService.tooltip')}>
                  {t('callbackRules:fields.classOfService.label')}
                </SimpleTooltip>
              </Label>
              <div>
                <SelectClassOfService
                  value={formData.classOfServicesId}
                  onChange={(value) => handleFieldChange('classOfServicesId', value)}
                  classOfServices={classOfServices}
                  placeholder={t('callbackRules:fields.classOfService.placeholder')}
                />
              </div>

              <Label>
                <SimpleTooltip content={t('callbackRules:fields.askForCallbackNumber.tooltip', 'When enabled, the system prompts the caller via DTMF to enter the number they want to receive the callback on, instead of using their Caller ID.')}>
                  {t('callbackRules:fields.askForCallbackNumber.label', 'Ask for Callback Number')}
                </SimpleTooltip>
              </Label>
              <div>
                <Toggle value={formData.askForCallbackNumber} onChange={(value) => handleFieldChange('askForCallbackNumber', value)} />
              </div>

              <Label>
                <SimpleTooltip content={t('callbackRules:fields.enabled.tooltip')}>
                  {t('callbackRules:fields.enabled.label')}
                </SimpleTooltip>
              </Label>
              <div>
                <Toggle value={formData.enabled} onChange={(value) => handleFieldChange('enabled', value)} />
              </div>
            </div>
          </FormBox>

          <CallbackRuleSettingsSection
            settings={formData.settings}
            errors={errors}
            availableExtensions={availableExtensions}
            showAllowedCallersModal={showAllowedCallersModal}
            setShowAllowedCallersModal={setShowAllowedCallersModal}
            onSettingsChange={handleSettingsChange}
            onNotificationChange={handleNotificationChange}
            t={t}
          />
        </form>
      </div>

      <FixedActionBar
        onSaveWithAction={handleSaveWithAction}
        onCancel={handleCancel}
        onDelete={isEditMode ? () => setShowDeleteModal(true) : undefined}
        isEditMode={isEditMode}
        isSaving={isSaving}
        deleteDisabled={isDeleting}
        cancelText={t('common.cancel')}
        deleteText={t('common.delete')}
        useSaveDropdown={true}
        saveDropdownStorageKey="callbackRules:saveAction"
        saveDisabled={isSaving}
      />

      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirm}
        title={t('callbackRules:messages.deleteTitle')}
        message={t('callbackRules:messages.confirmDelete', { name: formData.name })}
        confirmText={t('common.delete')}
        cancelText={t('common.cancel')}
        type="danger"
        isLoading={isDeleting}
      />

      {/* Quick List Modal for Callback Rules */}
      <QuickSearchModal
        isOpen={showQuickList}
        onClose={() => {
          setShowQuickList(false);
          setQuickListSearch('');
        }}
        title={t('callbackRules:title')}
        items={quickListItems}
        isLoadingInitial={isLoadingInitial}
        isSearching={isQuickSearching}
        searchValue={quickListSearch}
        onSearchChange={setQuickListSearch}
        onItemSelect={(item) => {
          setShowQuickList(false);
          setQuickListSearch('');
          navigate(`/pbx/applications/callback/${item.uuid || item.id}`);
        }}
        currentItemId={id}
        renderItem={(item, isCurrent) => (
          <button
            onClick={() => {
              if (!isCurrent) {
                setShowQuickList(false);
                setQuickListSearch('');
                navigate(`/pbx/applications/callback/${item.uuid || item.id}`);
              }
            }}
            disabled={isCurrent}
            className={`w-full text-left p-3 rounded-md transition-colors ${isCurrent
              ? 'bg-primary/20 border-2 border-primary cursor-default'
              : 'hover:bg-gray-100 dark:hover:bg-gray-700 border border-border'
              }`}
          >
            <div className="flex items-center gap-3">
              <PhoneIncoming className="h-4 w-4 text-primary flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="font-mono font-semibold text-foreground">
                    {item.code}
                  </span>
                  {isCurrent && (
                    <span className="px-2 py-0.5 text-xs font-medium bg-primary text-primary-foreground rounded">
                      {t('callbackRules.current', 'Current')}
                    </span>
                  )}
                </div>
                {item.name && (
                  <div className="text-sm text-muted-foreground truncate">
                    {item.name}
                  </div>
                )}
              </div>
            </div>
          </button>
        )}
        searchPlaceholder={t('common.searchPlaceholder')}
        minCharsMessage={t('callbackRules.quickListMinChars', 'Type at least 2 characters to search')}
        emptyMessage={t('callbackRules.quickListEmpty', 'Start typing to search callback rules')}
        noResultsMessage={t('callbackRules.quickListNoResults', 'No callback rules found')}
        headerIcon={<PhoneIncoming className="h-5 w-5" />}
        minSearchChars={2}
      />
    </div>
  );
}

